<script setup lang="ts">
const props = defineProps<{ vacancy: BaseVacancy }>()

const emits = defineEmits(['refresh'])

const { t } = useI18n({
  useScope: 'local',
})

// Only for stagedoos at the moment
// Needs to be tested for volunteerly
const canArchiveOrRestore = useAppConfig().app.isStagedoos
const isArchived = computed(() => props.vacancy.status == 'archived')

const isArchiveModalOpen = ref(false)
const closeArchiveModal = () => (isArchiveModalOpen.value = false)

const isDeleteModalOpen = ref(false)
const closeDeleteModal = () => (isDeleteModalOpen.value = false)

const { vacancyTypeName, vacancyTypeNameCapitalized }
  = useVacancyTypeName(props.vacancy)
</script>

<template>
  
  <div class="absolute end-0 top-2 z-20">
    <BaseDropdown
      flavor="context"
      label="Dropdown"
      orientation="end"
      condensed
      class="z-20"
      shape="curved"
    >
      <BaseDropdownItem
        :to="`/vacancies/${vacancy.id}/edit`"
        :title="t('editMenuTitle', { vacancyTypeName, vacancyTypeNameCapitalized })"
      >
        <template #start>
          <IconEdit class="me-2 block size-5" />
        </template>
      </BaseDropdownItem>
      <LazyBaseDropdownDivider />

      <template v-if="canArchiveOrRestore">
        <BaseDropdownItem
          :key="vacancy.status"
          :title="isArchived ? t('restoreMenuTitle') : t('archiveMenuTitle')"
          @click="isArchiveModalOpen = true"
        >
          <template #start>
            <Icon name="ph:archive-duotone" class="me-2 block size-5" />
          </template>
        </BaseDropdownItem>
        <LazyBaseDropdownDivider />
      </template>

      <BaseDropdownItem
        :title="
          t('deleteMenuTitle', {
            vacancyTypeName,
            vacancyTypeNameCapitalized,
          })
        "
        @click="isDeleteModalOpen = true"
      >
        <template #start>
          <IconDelete class="me-2 block size-5" />
        </template>
      </BaseDropdownItem>
    </BaseDropdown>
  </div>

  <VacancyDetailsDeleteModal
    :open="isDeleteModalOpen"
    :vacancy="vacancy"
    @close="closeDeleteModal"
  />

  <VacancyDetailsArchiveAndRestoreModal
    :key="vacancy.status"
    :open="isArchiveModalOpen"
    :vacancy="vacancy"
    @close="closeArchiveModal"
    @archived="emits('refresh')"
    @restored="emits('refresh')"
  />
</template>

<i18n lang="json">
{
  "en": {
    "editMenuTitle": "Edit",
    "archiveMenuTitle": "Archive",
    "restoreMenuTitle": "Restore",
    "deleteMenuTitle": "Delete"
  },
  "nl": {
    "editMenuTitle": "Bewerken",
    "archiveMenuTitle": "Archiveren",
    "restoreMenuTitle": "Herstellen (de-archiveren)",
    "deleteMenuTitle": "Verwijderen"
  }
}
</i18n>
